export const PHASE_1_END = 0.35;
export const PHASE_2_END = 1;

export const TITLE_SCALE_START = 0.4117;
export const PICTOGRAM_SCALE_START = 0.6166;
